import { handleActions } from 'redux-actions'
import * as actions from '../actions'

const defaultValue = []

export default handleActions(
  {
    [actions.addModelToBentleyAnalyticsReport](state, action) {
      return [...state, action.payload]
    },
    [actions.deleteModelFromBentleyAnalyticsReport](state, action) {
      const index = action.payload
      return [...state.slice(0, index), ...state.slice(index + 1)]
    },
    [actions.closeBentleyAnalyticsReportDialog](state, action) {
      return defaultValue
    },
    [actions.resetState](state, action) {
      return defaultValue
    },
  },
  defaultValue
)
